import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomerTenderService {
  apiUrl: string = environment.API_SERVER;
  procurementUrl: string = environment.PROCUREMENT_API_SERVER;
  constructor(private _httpClient: HttpClient) {}
  getAllCustomerTenders(payload): Observable<any> {
    return this._httpClient.get(`${this.procurementUrl}/public/tender`, {
      params: payload.params,
    });
  }
  getProcurementCategories(): Observable<any> {
    return this._httpClient.get(
      `${this.procurementUrl}/public/tender/categories`
    );
  }
  getProcurementTenderStages(): Observable<any> {
    return this._httpClient.get(
      `${this.procurementUrl}/public/tender/bidding-stages`
    );
  }
  getProcurementCycle(payload): Observable<any> {
    return this._httpClient.get(
      `${this.procurementUrl}/proc-cycles/get-all-proc-cylces/`,
      { params: payload.params }
    );
  }

  printSubmissionSlip(payload): Observable<any> {
    return this._httpClient.post(
      `${this.procurementUrl}/submission-slip`,
      payload.body
    );
  }

  getSubmissionSlips(payload): Observable<any> {
    return this._httpClient.get(`${this.procurementUrl}/submission-slip/`, {
      params: payload.params,
    });
  }

  getSubmissionSlip(payload): Observable<any> {
    return this._httpClient.get(
      `${this.procurementUrl}/submission-slip/${payload.submissionSlipId}`
    );
  }
}
